import { render } from "./Drink.vue?vue&type=template&id=2df6077e&scoped=true"
import script from "./Drink.vue?vue&type=script&lang=js"
export * from "./Drink.vue?vue&type=script&lang=js"

import "./Drink.vue?vue&type=style&index=0&id=2df6077e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2df6077e"

export default script